/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CLandingpageColorKey {
    BRAND_COLOR = 'BrandColor',
    ACCENT_COLOR = 'AccentColor',
}
